import BDropdown from "./BDropdown"

export { BDropdown }

export default BDropdown;